<template>
  <div>
    <!-- Campo de seleção do item a ser avaliado -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-select
          v-model="avaliacao"
          :items="avaliacoesForm"
          :label="status"
          item-text="avaliado.nome"
          return-object
        />
      </v-col>
    </v-row>

    <!-- Lista de itens a serem avaliados -->
    <v-row no-gutters>
      <v-col cols="12">
        <avaliacao-form-gestor-list
          :value="listaForm"
          :disabled="!avaliacao"
        />
      </v-col>
    </v-row>

    <!-- Botão para Avaliar -->
    <v-row class="justify-end" no-gutters>
      <v-spacer />
      <v-tooltip
        :disabled="notasNaoPreenchidas || avaliacoesForm.length === 0"
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="notasNaoPreenchidas || avaliacoesForm.length === 0"
            class="mt-4"
            color="primary"
            @click="avaliar"
            v-on="on"
          >
            Avaliar
          </v-btn>
        </template>
        <span>Clique no botão para realizar a avaliação</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AvaliacaoFormGestorList from '@/components/diagnostico/AvaliacaoFormGestorList';

const itemAvaliacaoRepository = RepositoryFactory.get('itemAvaliacao');

export default {
  name: 'AvaliacaoFormGestor',

  components: { AvaliacaoFormGestorList },

  props: {
    avaliacoes: {
      type: Array,
      required: true,
    },
    lista: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    escalas: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      avaliacao: null,
      listaForm: [],
    };
  },

  computed: {
    itens: {
      get() {
        return this.$store.state.diagnostico.itens;
      },
      set(itens) {
        this.$store.dispatch('diagnostico/setItens', itens);
      },
    },
    itensAvaliacoes() {
      return this.$store.state.diagnostico.itens
        .filter((i) => this.avaliacoesComResponsabilidades.some((a) => a.id === i.avaliacao.id));
    },
    avaliacoesComResponsabilidades() {
      return this.avaliacoes.filter(
        (a) => this.$store.state.diagnostico.responsabilidades
          .some((r) => r.unidade.id === a.avaliado.unidadeVersao.id),
      );
    },
    avaliacoesForm() {
      return this.avaliacoesComResponsabilidades
        .filter(
          (a) => !this.itensAvaliacoes.some((i) => i.avaliacao.avaliado.id === a.avaliado.id)
            && this.$store.state.diagnostico.responsabilidades
              .some((r) => r.unidade.id === a.avaliado.unidadeVersao.id),
        );
    },
    status() {
      const total = this.avaliacoesComResponsabilidades.length;
      return `${total - (total - this.avaliacoesForm.length)} itens restantes`;
    },
    notasNaoPreenchidas() {
      return this.listaForm.some((a) => !a.nota.rating);
    },
  },

  watch: {
    avaliacao() {
      this.set();
    },
    avaliacoesForm() {
      this.selecionar();
    },
  },

  created() {
    this.selecionar();
  },

  methods: {
    set() {
      if (this.avaliacao) {
        this.listaForm = this.lista.filter((item) => item.unidade.id === this.avaliacao.avaliado.unidadeVersao.id)
          .map((item) => ({
            fator: null,
            responsabilidade: { ...item },
            nota: { rating: 0 },
            naoAplica: false,
          }));
      }
    },
    avaliar() {
      const payload = this.listaForm.map((item) => ({
        avaliacao: { ...this.avaliacao },
        fator: null,
        responsabilidade: item.responsabilidade,
        nota: this.getNota(item.nota.rating),
        naoAplica: false,
      }));

      itemAvaliacaoRepository.create(payload).then((response) => {
        const itens = response.data;

        // Sobrescrita da nota porque ela será NULL caso o item esteja como naoAplica
        // Sobrescrita da avaliação porque o back-end não estava respondendo o nome do avaliado
        this.itens.push(
          ...itens.map((i) => ({
            ...i,
            nota: i.nota || { rating: 0 },
            avaliacao: this.avaliacoesComResponsabilidades.find((a) => a.id === i.avaliacao.id),
          })),
        );
        this.$store.dispatch('app/success', { response, message: 'Avaliações cadastradas com sucesso!' });
      });
    },
    selecionar() {
      if (this.avaliacoesForm.length > 0) {
        this.avaliacao = { ...this.avaliacoesForm[0] };
      } else {
        this.avaliacao = null;
        this.$emit('done');
      }
      this.zerarNotas();
    },
    zerarNotas() {
      this.listaForm.forEach((item) => {
        item.nota.rating = 0;
      });
    },
    getNota(rating) {
      const index = this.escalas.findIndex((e) => e.rating === rating);
      if (index !== -1) {
        return this.escalas[index];
      }
    },
  },
};
</script>
